<template>
    <canvas ref="mob"></canvas>
</template>

<script>
    export default {
        props: ['mob'],
        data() {
            return {
                mobdata: null,
                sprite_height: 512,
                sprite_width: 512,
                border_width: 0,
                spacing_width: 0,
                col: 0,
                row: 9,
                ctx: null,
                image: null,
                animationInterval: null,
                heartimage: null,
                state: 'idle'
            }
        },

        watch: {
            mob(data, olddata) {
                if (data != olddata && data != null) {
                    this.mobdata = data;
                    this.state = "idle";
                    this.loadImage();
                } else if (data == null) {
                    this.mobdata = olddata;
                    this.dead();
                }
            },
            state(data, olddata) {
                if (data != olddata) this.draw()
            }
        },
        mounted() {
            this.heartimage = new Image();
            this.heartimage.src = '/images/dartrpg/heart.png';
            this.mobdata = this.mob;
            this.ctx = this.$refs['mob'].getContext('2d');
            var r = this.$refs['mob'].parentElement.getBoundingClientRect();
            this.$refs['mob'].width = r.width;
            this.$refs['mob'].height = r.height;
            if (this.mobdata == null) return;
            this.loadImage();
        },
        beforeDestroy() {
            clearInterval(this.animationInterval);
            console.log("deleting mob" + this.mobdata.name);
        },
        methods: {
            attack() {
                this.state = "attacking";
            },
            idle() {
                this.state = "idle";
            },
            dead() {
                this.mobdata.hp = 0;
                this.mobdata.alive = false;
                this.col = 0;
                this.row = 3;
            },
            spritePositionToImagePosition(row, col) {
                return {x: (this.border_width +col * (this.spacing_width + this.sprite_width)),
                        y: (this.border_width +row * (this.spacing_width + this.sprite_height))}
            },
            loadImage() {
                if (this.image && this.image.src.indexOf(this.mobdata.spritesheet) != -1) {
                    this.draw();
                } else {
                    this.image = new Image();
                    this.image.src = '/images/dartrpg/'+this.mobdata.spritesheet+'.png';
                    this.image.onload = () => {
                        this.draw();
                    }
                }
            },
            draw() {
                if (this.mobdata == null) return;
                if (this.state == "dead") return;
                if (this.mobdata.type == 0) {
                    if (this.state == 'idle')
                        this.row = 12; //hero idle
                    else if (this.state == 'attacking') {
                        this.row = 14; //hero attack
                    }
                } else {
                    if (this.mobdata.alive) {
                        this.row = 0;
                    } else {
                        this.row = 3;
                    }
                }
                clearInterval(this.animationInterval);
                this.col = 0;
                this.animationInterval = setInterval(() => {
                    if (this.mobdata.type == 0) {
                        this.animateIdle();
                    }
                    else {
                        if (this.mobdata.alive)
                        this.animateIdle();
                    else
                        this.animateDie();
                    }
                }, 250);
            },
            debug() {
                this.ctx.font = "30px Arial";
                this.ctx.fillStyle = "white";
                this.ctx.textAlign = "center";
                // this.ctx.fillText(this.image.src, this.sprite_width-500, this.sprite_height/2);
            },
            animateIdle() {
                this.ctx.clearRect(0,0,this.sprite_width, this.sprite_height);
                this.col += 1;
                if (this.col == 4) {
                    this.col = 0;
                    if (this.state == "attacking") {
                        this.row = 12;
                        this.idle();
                    }
                }
                var position = this.spritePositionToImagePosition(this.row,this.col);
                this.drawImage(position.x, position.y)
            },
            animateDie() {
                if (this.col == 3) {
                    clearInterval(this.animationInterval)
                    this.state = "dead";
                    setTimeout(() => {
                        this.ctx.clearRect(0,0,this.sprite_width, this.sprite_height);
                    }, 100);
                } else {
                    this.ctx.clearRect(0,0,this.sprite_width, this.sprite_height);
                    this.col += 1;
                }
                var position = this.spritePositionToImagePosition(this.row,this.col);
                this.drawImage(position.x, position.y)
            },

            drawImage(x,y) {
                this.ctx.drawImage(
                    this.image,
                    x,
                    y,
                    this.sprite_width,
                    this.sprite_height,
                    0,
                    0,
                    this.sprite_width/2,
                    this.sprite_height/1.5
                )

                if (this.mobdata.hp && this.mobdata.hp > 0) {
                    this.ctx.drawImage(
                        this.heartimage,
                        0,
                        0,
                        this.sprite_width,
                        this.sprite_height,
                        this.sprite_width/5.5,
                        0,
                        this.sprite_width/1.5,
                        this.sprite_height/1.5
                    )
                    this.ctx.font = "30px Arial";
                    this.ctx.fillStyle = "white";
                    this.ctx.textAlign = "center";
                    this.ctx.fillText(this.mobdata.hp, this.sprite_width/5.5+40, 42);
                }
            },
            deleteCurrentImage() {
                this.ctx.clearRect(0,0,this.sprite_width, this.sprite_height);
            }
        }
    }
</script>
